import { useEffect } from 'react';
import { Preloader } from '@/components/Preloader';
import { MiniFaqs, MINIFAQ_SOURCES } from '@/containers/MiniFaqs';
import { USER_STATUSES } from '@/helpers/constants';
import { useGetWithdrawInfo } from '@/query/queries/cash/useGetWithdrawInfo';
import { SuspendResidenceWarning } from '@/components/Warnings/SuspendResidenceWarning';
import { useGetMe } from '@/hooks/useGetMe';
import { WithdrawDecisionWidget } from './components/WithdrawDecisionWidget';
import { WithdrawHistory } from './components/WithdrawHistory';
import { MessageHandler } from './components/MessageHandler';
import { WithdrawForm } from './components/WithdrawForm';
import AnalyticsGA from '@/analyticsGA';
import s from './index.module.scss';

const FundsWithdrawPage = () => {
  const { profile, isVerified } = useGetMe();
  const { isLoading } = useGetWithdrawInfo();

  useEffect(() => {
    AnalyticsGA.pageNavigation('Withdraw', 'finance_operations');
  }, []);

  if (!profile || isLoading) {
    return (
      <div className={s.page}>
        <Preloader className={s.preloader} />
      </div>
    );
  }

  if (profile?.status === USER_STATUSES.suspended) {
    return (
      <div className={s.page}>
        <SuspendResidenceWarning />
      </div>
    );
  }

  return (
    <div className={s.page}>
      {isVerified ? (
        <>
          <WithdrawForm>
            <WithdrawDecisionWidget />
          </WithdrawForm>
          <WithdrawHistory />
        </>
      ) : (
        <MessageHandler />
      )}
      <MiniFaqs source={MINIFAQ_SOURCES.withdraw} />
    </div>
  );
};

export default FundsWithdrawPage;
